module.exports = __webpack_public_path__ + "static/Crystal2-01d7ca8ecfe5fc2a5d2ae55c8f9e2509.png";